module.exports = __webpack_public_path__ + "static/media/MARAM ALZIR.db673633.png";